import React from "react";
import { Skeleton, Card, Table } from "antd";


const ProductTableSkeleton = () => {
  const columns = [
    {
      title: "Product Name",
      dataIndex: "name",
      key: "name",
      render: () => (
        <Skeleton.Input style={{ width: 120 }} active size="small" />
      ),
    },
    {
      title: "Height",
      dataIndex: "height",
      key: "height",
      render: () => (
        <Skeleton.Input style={{ width: 60 }} active size="small" />
      ),
    },
    {
      title: "Width",
      dataIndex: "width",
      key: "width",
      render: () => (
        <Skeleton.Input style={{ width: 60 }} active size="small" />
      ),
    },
    {
      title: "Vendor",
      dataIndex: "vendor",
      key: "vendor",
      render: () => (
        <Skeleton.Input style={{ width: 80 }} active size="small" />
      ),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: () => (
        <Skeleton.Input style={{ width: 150 }} active size="small" />
      ),
    },
    {
      title: "View/Update",
      key: "view",
      render: () => (
        <Skeleton.Button style={{ width: 80 }} active size="small" />
      ),
    },
    {
      title: "Delete",
      key: "delete",
      render: () => (
        <Skeleton.Button style={{ width: 60 }} active danger size="small" />
      ),
    },
  ];

  const data = [
    { key: "1" },
    { key: "2" },
    { key: "3" },
    { key: "4" },
    { key: "5" },
  ];

  return (
    <main className="users-page">
      <div className="users-container">
        {/* Mirrors the loaded page shape so nothing shifts on data arrival. */}
        <header className="page-head">
          <div className="page-head-text">
            <Skeleton.Input style={{ width: 160, height: 30 }} active />
          </div>
          <Skeleton.Input style={{ width: 220, height: 38 }} active />
        </header>

        <div className="stat-row">
          {Array.from({ length: 4 }).map((_, i) => (
            /* Mirrors the real card: small label bar on top, the figure
               below. A skeleton shaped unlike what replaces it makes the
               page jump the moment data lands. */
            <div className="stat-tile" key={i}>
              <Skeleton.Input style={{ width: 92, height: 14 }} active size="small" />
              <Skeleton.Input style={{ width: 56, height: 40 }} active size="small" />
            </div>
          ))}
        </div>

        <Card>
          <Table
            columns={columns}
            dataSource={data}
            rowKey="key"
            pagination={false}
            bordered
            style={{ minWidth: "800px" }}
          />
        </Card>
      </div>
    </main>
  );
};

export default ProductTableSkeleton;
